import React, { useEffect, useState, useTransition } from 'react';
import {
  Modal,
  Box,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import i18n from '../../../../i18n';
import { LocaleKey } from '../../../localizedGrid/locales';
import HtmlComponent from './HtmlComponent';
import { usePublicDoc } from '../../../../hooks/usePublicDoc';

interface InfoModalProps {
  open: boolean;
  onCancel: () => void;
  kind: 'offer' | 'privacy';
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  pt: 10,
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
};

const InfoModal: React.FC<InfoModalProps> = ({ open, onCancel, kind }) => {
  const lang = i18n.language as LocaleKey;
  const { data: content, loading } = usePublicDoc( kind == 'offer' ? 'offer.html' : 'privacy.html', lang);
  
  return (
    <Modal
      open={open}
      onClose={onCancel}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <IconButton
          aria-label="close"
          onClick={onCancel}
          sx={{
            position: 'absolute',
            right: 16,
            top: 16,
            color: (theme) => theme.palette.grey[500],
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>        

        <div id="modal-modal-description">
          <HtmlComponent htmlContent={content}/>
        </div>

        </Box>
    </Modal>
  );
};

export default InfoModal;